'use strict';

const $ = require('jquery');
const util = require('../utils/util');
const Dialog = require('../lib/dialog').default;
const flyin = require('../flyins/flyin');
const privacyOverlay = require('../components/privacy-overlay');
const storeListTemplate = require('./stores-searchlist.mustache');
const storeDetailTemplate = require('./store-infowindow.mustache');
// change position postalCode <-> city for specific countries
const specialStoreListTemplate = require('./special-stores-searchlist.mustache');
const specialStoreDetailTemplate = require('./special-store-infowindow.mustache');
const svgMarker = require('./icon_storefinder_marker.svg');
const svgMarkerOrange = require('./icon_storefinder_marker_orange.svg');
const svgReferencePin = require('./icon_storefinder_reference_pin.svg');
const collectionPoint = require('./checkout/collectionPoint');

var map;
var latCenter = $('#store-latitude').val(); // using to set center at the first time
var lonCenter = $('#store-longitude').val(); // using to set center at the first time
var latSelected = latCenter;
var lonSelected = lonCenter;
var country = $('#store-country').val(); // using to get city within this country
var googleMapURL = $('#store-googleMapURL').val(); // using to generate direction link to google
var autocomplete;
var autocompleteColissimo;
var markers = [];
var zoom = parseInt($('#store-zoomlevel').val(), 10) || 8;
var defaultDistance = $('.store-select-distance option:first').val();
var refreshWhenZoom = true; // Prevent event zoom map when refresh store
var mapinputid = 'dwfrm_singleshipping_collectionPoint_mapAddress';
var pointInputId = 'dwfrm_singleshipping_collectionPoint_collectionAddress';
var checkout = $('#' + mapinputid).length > 0;
var $searchInput;
if (checkout) {
    $searchInput = $('#' + mapinputid);
} else {
    $searchInput = $('#store-search-text');
}
var searchString = $searchInput.val();
var searchStoreID = $('#store-storeid').val();
var $countResult = $('.count-results');
var $numberResult = $('.store-search-title .number-result');
var storeLocatorType = $('#store-storeLocatorType').val() || 'regular';
var enabled = $('#gpac-config').data('enabled');
let $searchPointInput = $('#' + pointInputId);
const $collectionPointsContainer = $('#collectionPoints');

function metersPerPixel(latLng, zoomLevel) {
    return (
        (156543.03392 * Math.cos((latLng.lat() * Math.PI) / 180)) / // eslint-disable-line no-mixed-operators
        Math.pow(2, zoomLevel)
    );
}

/**
 * Get distance depend on current selected distance and zoom level
 *
 * @returns {Number}
 */
function getDistanceFollowZoom() {
    /* var distance = $('.store-select-distance').val();
    var currentZoom = map.getZoom();
    if (currentZoom < 7) {
        distance = 9999;
    }
    return distance; */
    var $mapEl = $('#google_map');
    var width = $mapEl.width();
    var height = $mapEl.height();
    return Math.max(
        30,
        (Math.max(width, height) * // eslint-disable-line no-mixed-operators
            metersPerPixel(map.getCenter(), map.getZoom())) /
            1000 /
            2
    ); // eslint-disable-line no-mixed-operators
}

// Remove the google fonts global links related to google maps API from the store locator page

var head = document.getElementsByTagName('head')[0];
var insertBefore = head.insertBefore;

head.insertBefore = function (newElement, referenceElement) {
    if (newElement.href && newElement.href.indexOf('https://fonts.googleapis.com/css?family=') === 0) {
        return;
    }

    insertBefore.call(head, newElement, referenceElement);
};

/**
 * Show store detail when user click a marker on google map
 *
 * @param {Object} storeInfo - store info data
 * @returns {string}
 */
function showDetailWhenClickOnMarker(storeInfo) {
    var storeTypeClassMappings = $('.store-wrapper').data('color-mapped');
    //change position postalCode <-> city for specific countries
    if (
        storeInfo.countryCode === 'DE' ||
        storeInfo.countryCode === 'AT' ||
        storeInfo.countryCode === 'ES' ||
        storeInfo.countryCode === 'IT'
    ) {
        return specialStoreDetailTemplate(
            $.extend(
                {
                    className: storeTypeClassMappings[storeInfo.storeType],
                    directionLink:
                        storeInfo.storeLocatorURL ||
                        googleMapURL +
                            encodeURI(
                                ['address1', 'address2', 'city', 'postalCode', 'state', 'countryCode', 'typeDePoint']
                                    .map(function (field) {
                                        return storeInfo[field];
                                    })
                                    .filter(function (value) {
                                        return value !== null;
                                    })
                                    .join(', ')
                            ),
                    phoneSymbol: Resources.PHONE_SYMBOL,
                    distanceLabel: Resources.DISTANCE,
                    directionCaption: Resources.GET_DIRECTION,
                    shopDetails: Resources.SHOP_DETAILS,
                    businessHours: Resources.BUSINESS_HOURS,
                    events: Resources.EVENTS,
                    detailsCaption: Resources.DETAILS_CAPTION,
                    selectButtonCaption: Resources.SELECT_BUTTON_CAPTION,
                    checkout: checkout
                },
                storeInfo
            )
        );
    } else {
        return storeDetailTemplate(
            $.extend(
                {
                    className: storeTypeClassMappings[storeInfo.storeType],
                    directionLink:
                        storeInfo.storeLocatorURL ||
                        googleMapURL +
                            encodeURI(
                                ['address1', 'address2', 'city', 'postalCode', 'state', 'countryCode', 'typeDePoint']
                                    .map(function (field) {
                                        return storeInfo[field];
                                    })
                                    .filter(function (value) {
                                        return value !== null;
                                    })
                                    .join(', ')
                            ),
                    phoneSymbol: Resources.PHONE_SYMBOL,
                    distanceLabel: Resources.DISTANCE,
                    directionCaption: Resources.GET_DIRECTION,
                    shopDetails: Resources.SHOP_DETAILS,
                    businessHours: Resources.BUSINESS_HOURS,
                    events: Resources.EVENTS,
                    detailsCaption: Resources.DETAILS_CAPTION,
                    selectButtonCaption: Resources.SELECT_BUTTON_CAPTION,
                    checkout: checkout
                },
                storeInfo
            )
        );
    }
}

function removeAllMarkers() {
    var i;
    for (i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers = [];
}

function produceSVGDataURL(svg) {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
}

function showStoresOnMap(stores) {
    var googleMaps = window.google.maps;
    var infowindow = new googleMaps.InfoWindow({
        disableAutoPan: true
    });
    var storeTypeMarkerColors = $('.store-wrapper').data('icon-colors');
    var marker;
    var i;
    var orangeHexCode = '#C99E1C';
    removeAllMarkers();
    if (stores.storeLocatorType === 'collectionpoint') {
        latSelected = stores.latitude;
        lonSelected = stores.longitude;
    }
    marker = new googleMaps.Marker({
        position: new googleMaps.LatLng(latSelected, lonSelected),
        map: map,
        icon: {
            scaledSize: new googleMaps.Size(30, 40),
            anchor: new googleMaps.Point(15, 40),
            url: produceSVGDataURL(svgReferencePin)
        },
        optimized: false
    });
    markers.push(marker);

    googleMaps.event.addListener(infowindow, 'closeclick', function () {
        $('.store-search-results>ul>li.active').removeClass('active');
    });

    for (i = 0; i < Object.keys(stores).length; i++) {
        // Add marker
        if (storeTypeMarkerColors[stores[i].storeType] == orangeHexCode) {
            marker = new googleMaps.Marker({
                position: new googleMaps.LatLng(stores[i].latitude, stores[i].longitude),
                map: map,
                // icon: storeTypeMarkerMappings[stores[i].storeType] || markerPath
                icon: {
                    scaledSize: new googleMaps.Size(22, 30),
                    anchor: new googleMaps.Point(11, 30),
                    url: produceSVGDataURL(
                        svgMarkerOrange.replace(/@COLOR@/, storeTypeMarkerColors[stores[i].storeType] || orangeHexCode)
                    )
                },
                optimized: false
            });
        } else {
            marker = new googleMaps.Marker({
                position: new googleMaps.LatLng(stores[i].latitude, stores[i].longitude),
                map: map,
                // icon: storeTypeMarkerMappings[stores[i].storeType] || markerPath
                icon: {
                    scaledSize: new googleMaps.Size(22, 30),
                    anchor: new googleMaps.Point(11, 30),
                    url: produceSVGDataURL(
                        svgMarker.replace(/@COLOR@/, storeTypeMarkerColors[stores[i].storeType] || '#023f85')
                    )
                },
                optimized: false
            });
        }

        // add event click on marker (show store information)
        googleMaps.event.addListener(
            marker,
            'click',
            (function (theMarker, i2) {
                // eslint-disable-line no-loop-func
                return function () {
                    var $parentDiv = $('.store-search-results>ul');
                    var $selectedItem = $('.store-search-results>ul>li#' + i2);
                    var parentDivScrollTop;
                    var selectedItemPositionTop;
                    var parentDivPositionTop;
                    var parentDivHalfHeight;
                    var selectedItemHeight;
                    var latLng;
                    var markerLat;
                    var markerLon;
                    // remove active class, add active class for new item and scroll to its position
                    $parentDiv.find('li.active').removeClass('active');
                    $selectedItem.addClass('active');

                    parentDivScrollTop = $parentDiv.scrollTop();
                    selectedItemPositionTop = $selectedItem.position().top;
                    parentDivPositionTop = $parentDiv.position().top;
                    parentDivHalfHeight = $parentDiv.height() / 2;
                    selectedItemHeight = $selectedItem.height();
                    /* eslint-disable no-mixed-operators */
                    if (!util.isMobile() && !util.isTablet()) {
                        $parentDiv.scrollTop(
                            parentDivScrollTop +
                                (selectedItemPositionTop - parentDivPositionTop) -
                                parentDivHalfHeight +
                                selectedItemHeight
                        );
                    } else {
                        $parentDiv.scrollTop(
                            parentDivScrollTop +
                                (selectedItemPositionTop - parentDivPositionTop) -
                                parentDivHalfHeight -
                                selectedItemHeight
                        );
                    }
                    /* eslint-enable operators */
                    refreshWhenZoom = false;
                    if ($('.store-search-results').hasClass('active') && (util.isMobile() || util.isTablet())) {
                        $('.store-search-results').toggleClass('active');
                        $countResult.hide();
                    }
                    map.setZoom(15);
                    latLng = theMarker.getPosition();
                    // fix UI issue
                    markerLat = latLng.lat();
                    markerLon = latLng.lng();
                    // add 0.004 for latitude to fix issue UI
                    latLng = new googleMaps.LatLng(markerLat + 0.004, markerLon);
                    map.setCenter(latLng);
                    infowindow.setContent(showDetailWhenClickOnMarker(stores[i2]));
                    infowindow.open(map, theMarker);
                    flyin.init();
                };
            })(marker, i)
        );

        // Push the marker to the 'markers' array, using it to remove old maker before add new marker
        markers.push(marker);
    }
    // bound all marker
    // fitBoundMarker ();
}

/**
 * Show store on search list
 *
 * @param {Object} stores - stores data
 */
function showStoresOnSearchList(stores) {
    const $resultsArea = $('.store-search-results');
    const $resultList = $resultsArea.find('ul');
    let store;
    const fieldNameMapper = function (field) {
        return store[field];
    };
    let i;
    let $item;
    const storeTypeClassMappings = $('.store-wrapper').data('color-mapped');

    // remove all old results
    $resultList.empty();

    for (i = 0; i < Object.keys(stores).length; i++) {
        store = stores[i];
        // change position postalCode <-> city for specific countries
        if (
            store.countryCode === 'DE' ||
            store.countryCode === 'AT' ||
            store.countryCode === 'ES' ||
            store.countryCode === 'IT'
        ) {
            $item = $(
                specialStoreListTemplate(
                    $.extend(
                        {
                            idx: i,
                            className: storeTypeClassMappings[store.storeType],
                            directionLink:
                                store.storeLocatorURL ||
                                googleMapURL +
                                    encodeURI(
                                        [
                                            'address1',
                                            'address2',
                                            'city',
                                            'postalCode',
                                            'state',
                                            'countryCode',
                                            'typeDePoint'
                                        ]
                                            .map(fieldNameMapper)
                                            .join(', ')
                                    ),
                            distanceLabel: Resources.DISTANCE,
                            directionCaption: Resources.GET_DIRECTION,
                            selectButtonCaption: Resources.SELECT_BUTTON_CAPTION,
                            checkout: checkout
                        },
                        store
                    )
                )
            );
        } else {
            $item = $(
                storeListTemplate(
                    $.extend(
                        {
                            idx: i,
                            className: storeTypeClassMappings[store.storeType],
                            directionLink:
                                store.storeLocatorURL ||
                                googleMapURL +
                                    encodeURI(
                                        [
                                            'address1',
                                            'address2',
                                            'city',
                                            'postalCode',
                                            'state',
                                            'countryCode',
                                            'typeDePoint'
                                        ]
                                            .map(fieldNameMapper)
                                            .join(', ')
                                    ),
                            distanceLabel: Resources.DISTANCE,
                            directionCaption: Resources.GET_DIRECTION,
                            selectButtonCaption: Resources.SELECT_BUTTON_CAPTION,
                            checkout: checkout
                        },
                        store
                    )
                )
            );
        }
        $item.appendTo($resultList);
    }
}

/**
 * Filter stores based on showStoreType setting.
 * @param {Object} stores
 * @return {Object} only stores of type showStoreType.
 */
function filterStores(stores) {
    var filteredStores = {};
    var i = 0;

    if (storeLocatorType) {
        $.each(stores, function (key, val) {
            if (
                val.storeLocatorType === storeLocatorType ||
                val.storeLocatorType === 'all' ||
                (!val.storeLocatorType && storeLocatorType === 'regular')
            ) {
                filteredStores[i] = val;
                i++;
            }
        });
    } else {
        filteredStores = stores;
    }

    return filteredStores;
}

/**
 * Preffils Store Labels. Pass empty object if no stores were found.
 *
 * @param { Object } stats
 * @returns {void}
 */
function prefillStoreLabel(stats) {
    $('.store-select-types')
        .find('.label-info')
        .each(function () {
            let storeType;
            const reRes = /storetype-(\d+)-cnt/.exec(this.id);
            if (reRes) {
                storeType = reRes[1];
                this.innerHTML = '(' + (stats[storeType] || '0') + ')';
            }
        });
}

/**
 * Get store list, display on google map and search list
 *
 */
function getStore() {
    if ($collectionPointsContainer.find('.colissimo').length > 0) {
        collectionPoint.showColissimoPoints();
    } else if ($collectionPointsContainer.find('.js-dhl24').length > 0) {
        collectionPoint.showServicePoints();
    } else if ($collectionPointsContainer.find('.js-bpost').length > 0) {
        collectionPoint.showBpostPoints();
    } else {
        var googleMaps = window.google.maps;
        var distance = getDistanceFollowZoom();
        var distanceunit = $('#store-distanceunit').val();
        var searchText = $searchInput.val();
        var data = {
            latitude: latCenter,
            longitude: lonCenter,
            latituderef: latSelected,
            longituderef: lonSelected,
            storeid: searchStoreID,
            distance: Math.ceil(distance * (distanceunit === 'mi' ? 0.621371 : 1)),
            distanceunit: distanceunit,
            searchText: searchText,
            countryCode: country.toUpperCase(),
            storeLocatorType: storeLocatorType
        };

        $('.storetype-cb').each(function () {
            var id = this.id;
            if (/^storetype(\d+)$/.test(id) && this.checked) {
                data[id] = this.value;
            }
        });
        $.ajax({
            type: 'GET',
            url: Urls.getStoresJson,
            data: data,
            dataType: 'json',
            success: function (json) {
                var stores;
                var keys;
                var stats;
                var latLng;
                var location;
                var locationCenter;
                var locationReference;

                if (json.success) {
                    stores = filterStores(json.stores);
                    keys = Object.keys(stores);
                    stats = json.storeTypeStats;
                    location = json.location;
                    locationCenter = location.center;
                    locationReference = location.reference;
                    showStoresOnMap(stores);
                    showStoresOnSearchList(stores);
                    if (keys.length === 0) {
                        if (checkout) {
                            $countResult.html(Resources.NO_POINTS_FOUND).show();
                        } else {
                            $countResult.html(Resources.NO_SHOPS_FOUND).show();
                        }
                    } else {
                        $countResult.html('').hide();
                    }

                    if (stats) {
                        prefillStoreLabel(stats);
                    }

                    if (json.store) {
                        latCenter = locationCenter.lat;
                        lonCenter = locationCenter.lon;
                        latSelected = locationReference.lat;
                        lonSelected = locationReference.lon;
                        searchStoreID = null;
                        latLng = new googleMaps.LatLng(latCenter, lonCenter);
                        map.panTo(latLng);
                        markers[0].setMap(null);
                        googleMaps.event.trigger(markers[1], 'click');
                    }
                }
            }
        });
    }
}

/**
 * Handle show empty result for searching
 */
function storeNotFound() {
    if (checkout) {
        $countResult.html(Resources.NO_POINTS_FOUND).show();
    } else {
        $countResult.html(Resources.NO_SHOPS_FOUND).show();
    }
    // remove marker and search list
    removeAllMarkers();
    $('.store-search-results ul').empty();

    prefillStoreLabel({});
}

/**
 * Using google geocode to get coordinate from search text, show stores following this coordinate
 */
function getSearchResults() {
    const googleMaps = window.google.maps;
    const geocoder = new googleMaps.Geocoder();
    refreshWhenZoom = false;
    geocoder.geocode({address: searchString}, function (results, status) {
        var latLng;
        var $storeSearchResults = $('.store-search-results');
        var firstResult;
        var location;
        if (status === 'OK' && results.length >= 1) {
            firstResult = results[0];
            // If result is valid, address_components will always have lenght over 1
            if (firstResult.address_components.length > 1) {
                location = firstResult.geometry.location;
                latCenter = location.lat();
                lonCenter = location.lng();
                latSelected = latCenter;
                lonSelected = lonCenter;
                latLng = new googleMaps.LatLng(latCenter, lonCenter);
                map.panTo(latLng);
                getStore();
                // locationChosen = true;
                if (!$storeSearchResults.hasClass('active')) {
                    $storeSearchResults.toggleClass('active');
                    if ($countResult.html().trim() === '') {
                        $countResult.show();
                    }
                }
            } else {
                storeNotFound();
            }
        } else {
            storeNotFound();
        }
    });
    map.setZoom(zoom);
}

/**
 * Event when user type on input text, and choose a item from autocomplete list
 */
function onPlaceChanged() {
    let place = autocomplete.getPlace();
    const $storeSearchResults = $('.store-search-results');
    let loc;
    searchString = $searchInput.val();
    if (!place) {
        place = autocompleteColissimo.getPlace();
        searchString = $searchPointInput.val();
        $searchInput.val(searchString);
    }
    $searchInput.trigger('blur');
    $searchPointInput.trigger('blur');
    refreshWhenZoom = false;
    map.setZoom(zoom);
    if (place.geometry) {
        map.panTo(place.geometry.location);
        loc = place.geometry.location;
        latCenter = loc.lat();
        lonCenter = loc.lng();
        latSelected = latCenter;
        lonSelected = lonCenter;
        // Reset distance when search with a new text
        $('.store-select-distance').val(defaultDistance);
        getStore();
        // locationChosen = true;
        if (!$storeSearchResults.hasClass('active')) {
            $storeSearchResults.toggleClass('active');
            if ($countResult.html().trim() === '') {
                $countResult.show();
            }
        }
    }
}

function initDialog() {
    const dialog = new Dialog({
        html: Resources.SEARCH_AROUND_ERROR,
        additionalClasses: ['ui-front'],
        useLegacyContainer: true,
        canCloseOnBackdropClick: true,
        isModal: false,
        useLegacyBackdrop: true,
        hasCloseText: false,
        callback: () => {
            $('#dialog-container').addClass('storelocator-searcharound-error');
            $('body').addClass('ui-dialog-prevent-scroll');
            $('.dialog-content').append(
                '<button class="ui-dialog-titlebar-close"><span class="ui-icon ui-icon-closethick"></span></button>'
            );
            $('.ui-dialog-titlebar-close').on('click', event => {
                event.preventDefault();
                $('.ui-dialog').remove();
                $('body').removeClass('ui-dialog-prevent-scroll');
            });
        },
        closeCallback: () => {
            $('body').removeClass('ui-dialog-prevent-scroll');
        }
    });
    dialog.open();
}
/**
 * Get current user's position, get stores around this position and show on map
 */
function searchAroundLocation() {
    const googleMaps = window.google.maps;
    const $storeSearchResults = $('.store-search-results');
    $searchInput.val('');
    searchString = '';
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                var latLng;
                var coords = position.coords;
                latCenter = coords.latitude;
                lonCenter = coords.longitude;
                latSelected = latCenter;
                lonSelected = lonCenter;
                latLng = new googleMaps.LatLng(latCenter, lonCenter);
                map.panTo(latLng);
                if ($collectionPointsContainer.find('.colissimo, .js-dhl24, .js-bpost').length > 0) {
                    var geocoder = new google.maps.Geocoder();
                    geocoder.geocode({location: latLng}).then(response => {
                        if (response.results[0]) {
                            $searchInput.val(response.results[0].formatted_address);
                        }
                    });
                }
                getStore();
                // locationChosen = true;
                if (!$storeSearchResults.hasClass('active')) {
                    $storeSearchResults.toggleClass('active');
                    if ($countResult.html().trim() === '') {
                        $countResult.show();
                    }
                }
            },
            function () {
                initDialog();
            }
        );
    } else {
        initDialog();
    }
}

function initializeEvents() {
    $('body').on('click', '.show-privacy-overlay', function () {
        $('body').addClass('ui-dialog-position-fixed');
        privacyOverlay.initPrivacyOverlay().open();
    });

    var googleMaps = window.google.maps;
    var inputAutocomplete;
    var inputAutocompleteColissimo;
    // Initialize google map
    map = new googleMaps.Map(document.getElementById('google_map'), {
        zoom: zoom,
        center: new googleMaps.LatLng(latCenter, lonCenter),
        mapTypeId: googleMaps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        zoomControl: true
    });
    // Handling request search from other page
    if (searchString !== '') {
        getSearchResults();
    } else {
        // Show marker after load page
        getStore();
        // locationChosen = true;
    }
    $('.store-search-results').show();

    map.addListener('dragend', function () {
        /* if (map.getZoom() >= 12 || locationChosen) {
            return;
        } */
        if ($collectionPointsContainer.find('.colissimo, .js-dhl24, js-bpost').length === 0) {
            setTimeout(function () {
                var center = map.getCenter();
                latCenter = center.lat();
                lonCenter = center.lng();
                getStore();
            }, 500);
        }
    });

    map.addListener('zoom_changed', function () {
        var center;
        if (
            ((refreshWhenZoom && map.getZoom() <= zoom) || map.getZoom() <= 10) &&
            $collectionPointsContainer.find('.colissimo, .js-dhl24, js-bpost').length === 0
        ) {
            center = map.getCenter();
            latCenter = center.lat();
            lonCenter = center.lng();
            getStore();
        } else {
            refreshWhenZoom = true;
        }
    });

    // initialize autocomplete
    inputAutocomplete = document.getElementById(mapinputid) || document.getElementById('store-search-text');

    var options = {
        types: ['address'],
        componentRestrictions: {country: country}
    };

    if (enabled) {
        autocomplete = new googleMaps.places.Autocomplete(inputAutocomplete, options);
        autocomplete.addListener('place_changed', onPlaceChanged);
    }

    if (checkout) {
        inputAutocompleteColissimo = document.getElementById(pointInputId);

        if (enabled) {
            autocompleteColissimo = new googleMaps.places.Autocomplete(inputAutocompleteColissimo, options);
            autocompleteColissimo.addListener('place_changed', onPlaceChanged);
        }
        if (inputAutocompleteColissimo) {
            googleMaps.event.addDomListener(inputAutocompleteColissimo, 'blur', function () {
                let searchText = $searchPointInput.val();
                if (searchText.length > 0 && searchText !== searchString) {
                    getSearchResults();
                }
            });
        }
    }
    googleMaps.event.addDomListener(inputAutocomplete, 'blur', function () {
        var searchText = $searchInput.val();
        if (searchText.length > 0 && searchText !== searchString) {
            searchString = searchText;
            // Reset distance when search with a new text
            $('.store-select-distance').val(defaultDistance);
            getSearchResults();
        }
    });

    googleMaps.event.addDomListener(inputAutocomplete, 'keydown', function (e) {
        if (e.which === 13) {
            var searchText = $searchInput.val();
            if (searchText.length > 0 && searchText !== searchString) {
                searchString = searchText;
                getSearchResults();
            }
        }
    });

    $('.store-btn-search').on('click', function () {
        var searchText = $searchInput.val();
        if (searchText.length > 0 && searchText !== searchString) {
            searchString = searchText;
            getSearchResults();
        }
    });

    // event when user choose search around (mobile and tablet)
    $('.store-btn-search-around').on('click', function () {
        refreshWhenZoom = false;
        map.setZoom(zoom);
        searchAroundLocation();
    });

    $('.storetype-cb').on('change', function () {
        var $storeSelectTypes = $('.store-select-types');
        var storetypeChoices = $storeSelectTypes.find('.storetype-select');
        var allChoices = storetypeChoices.length;
        var selected = storetypeChoices.find('.storetype-cb:checked').length;
        var msg = Resources.STORETYPE_NONE;
        if (selected > 0) {
            if (selected !== allChoices) {
                msg = String.format(Resources.STORETYPE_SOME, selected, allChoices);
            } else {
                msg = Resources.STORETYPE_ALL;
            }
        }
        $storeSelectTypes.find('.toggle-info').html(msg);
        getStore();
    });

    // show store detail when user click on entry of search result list
    $(document).on('click', '.store-search-results ul li', function () {
        var id = $(this).attr('id');
        $('.store-search-results>ul>li.active').removeClass('active');
        $(this).addClass('active');
        googleMaps.event.trigger(markers[parseInt(id, 10) + 1], 'click');
    });

    // event collape/expande search result when user click on search title
    $numberResult.on('click', function () {
        var $parentDiv;
        var $selectedItem;
        $('.store-search-results').toggleClass('active');
        if ($('.store-search-results').hasClass('active')) {
            if ($countResult.html().trim() === '') {
                $countResult.show();
            }
            // fix issue: when user collapse search list, then he click on a marker, the postion of selected item will
            // be show wrong position
            $parentDiv = $('.store-search-results>ul');
            $selectedItem = $('.store-search-results>ul>li.active');
            if ($parentDiv.length > 0 && $selectedItem.length > 0) {
                $parentDiv.scrollTop(
                    $parentDiv.scrollTop() +
                        ($selectedItem.position().top - $parentDiv.position().top) - // eslint-disable-line no-mixed-operators,max-len
                        $parentDiv.height() / 2 -
                        $selectedItem.height()
                );
            }
        } else {
            $countResult.hide();
        }
    });
}

exports.init = function () {
    initializeEvents();
};
exports.panMap = function (latlng) {
    map.panTo(latlng);
};
exports.showStoresOnMap = showStoresOnMap;
exports.showStoresOnSearchList = showStoresOnSearchList;
